export default __webpack_public_path__ + "1af6e69892d807c210856719552b20f9.png";